<template>
  <div>
    <div v-if="calculatesZipcodeCache" class="alert alert-info">
      Hinweis: Da der Cache für dynamische PLZ berechnet wird, können gerade
      keine dynamischen Fakes erstellt werden.
    </div>
    <resource
      resource="customerProfile"
      resourceName="Fake"
      :attributes="[
        {
          name: 'sex',
          label: 'Geschlecht',
          type: 'SexSelector'
        },
        {
          name: 'name',
          label: 'Name'
        },
        {
          name: 'postcode',
          label: 'PLZ',
          type: 'PostcodeSelector',
          hideable: true,
          hideEvent: 'has-dynamic-zipcode'
        },
        {
          name: 'has_dynamic_zipcode',
          label: 'Dynamische PLZ',
          type: 'CheckboxSelector',
          value: false
        },
        {
          name: 'birthday',
          label: 'Geburtsdatum',
          type: 'BirthdaySelector',
          withRandomSelector: true
        },
        {
          name: 'physique',
          label: 'Figur',
          type: 'OptionSelector'
        },
        {
          name: 'i_search_for_activity',
          label: 'Ich suche',
          type: 'MultiOptionSelector',
          multiSelect: true
        },
        {
          name: 'interested_in_gender',
          label: 'Interessiert an',
          type: 'SexSelector',
          multiSelect: true
        },
        {
          name: 'height_in_cm',
          label: 'Größe (cm)',
          type: 'SliderSelector',
          max: 220,
          min: 140
        },
        {
          name: 'admin_notes',
          label: 'Admin Info',
          type: 'TextareaSelector',
          rows: 5
        }
      ]"
    >
      <div slot="title">
        <h4>Fake-Profil erstellen</h4>
      </div>
    </resource>
  </div>
</template>

<script lang="babel">
export default {
  computed: {
    calculatesZipcodeCache() {
      return this.$store.getters["backgroundTask/running"]('calculate-zipcode-cache');
    }
  }
}
</script>
